import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GurdServiceService } from './gurd-service.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})

export class SignalrCctvService {

  private baseUrlHub = this._baseUrlHub;

  private iSystemUser;
  private strUserPassword;

  private hubConnection: HubConnection;

  private _isHubConnected: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isHubConnected$ = this._isHubConnected.asObservable();

  private _hubErrorSubject = new Subject<any>();
  hubError$ = this._hubErrorSubject.asObservable();

  private _dashCamLiveStream = new Subject<any>();
  dashCamLiveStream$ = this._dashCamLiveStream.asObservable();

  constructor(
    private _tooltip: NotificationService,
    private authService: GurdServiceService,
  ) { }

  get _baseUrlHub(): string {
    return (environment.baseUrlHub && environment.cctvEnabled)
      ? `${environment.baseUrlHub.replace(/\/+$/, '')}/FleetYarCameraHub`
      : '';
  }

  public init() {

    this.iSystemUser = this.authService.decrypt(localStorage.getItem('ID') ?? null);
    this.strUserPassword = this.authService.decrypt(localStorage.getItem('pass') ?? null);

    if (this.baseUrlHub == null || this.baseUrlHub == undefined || this.baseUrlHub == '') {
      console.warn('baseUrlHub is not set. Please check your configuration.');
      return;
    }

    if (this.baseUrlHub && this.hubConnection?.state === 'Connected') {
      console.log('CCTV Hub is already connected');
      return;
    }

    if (!this.iSystemUser || !this.strUserPassword) {

      const storedId = localStorage.getItem('ID');
      const storedPass = localStorage.getItem('pass');

      this.iSystemUser = storedId ? this.authService.decrypt(storedId) : null;
      this.strUserPassword = storedPass ? this.authService.decrypt(storedPass) : null;

    }

    if (!this.iSystemUser || !this.strUserPassword) {
      console.error('Missing credentials after recovery attempt', {
        iSystemUser: this.iSystemUser,
        hasPassword: !!this.strUserPassword,
        CCTV: true
      });

      this.updateHubStatus(false);
      return;
    }

    this.startConnection();

  }

  private startConnection() {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(this.baseUrlHub + `?iSystemUser=${this.iSystemUser}&strUserPassword=${this.strUserPassword}`)
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .build();
    this.registerConnectionEvents();
    this.registerHubListeners();

    this.hubConnection
      .start()
      .then(() => {
        this.updateHubStatus(true);
        console.log('CCTV Connection started');
        this._tooltip.showSuccess('اتصال موفق به هاب دوربین‌ها')

      }).catch(err => {
        this.updateHubStatus(false);
        console.log('Error while starting CCTV connection: ' + err)
        this._tooltip.showError('عدم امکان اتصال به هاب دوربین‌ها');
      });
  }

  public async reconnect() {
    if (this.hubConnection.state !== 'Disconnected') return;

    try {
      await this.hubConnection.start();
      this.updateHubStatus(true);

    } catch { }
  }

  public async disconnect() {
    try {
      if (this.hubConnection) {
        await this.hubConnection.stop();
        this.updateHubStatus(false);
        console.log('CCTV Hub connection stopped');
      }
    } catch (err) {
      this.updateHubStatus(false);
      console.error('Error while stopping CCTV hub:', err);
    }
  }

  private registerConnectionEvents() {

    this.hubConnection.onclose((error) => {
      console.log('CCTV Hub disconnected', error);
      this.updateHubStatus(null);
    });

    this.hubConnection.onreconnecting((error) => {
      console.log('CCTV Hub reconnecting', error);
      this.updateHubStatus(false);
    });

    this.hubConnection.onreconnected((connectionId) => {
      console.log('CCTV Hub reconnected', connectionId);
      this.updateHubStatus(true);
    });

  }

  private registerHubListeners() {

    this.registerHubErrorListener();
    this.registerHubDashCamStreamsListener();

  }

  private updateHubStatus(isConnect: boolean) {
    this._isHubConnected.next(isConnect)
  }

  // فراخوانی هاب های سمت کلاینت

  private registerHubErrorListener() {
    this.hubConnection.on('HC_HubError', (model: any) => {
      this._hubErrorSubject.next(model);
    });
  }

  private registerHubDashCamStreamsListener() {
    this.hubConnection.on('HC_CameraLivedBatch', (model: any) => {
      this._dashCamLiveStream.next(model);
    });
  }

}
